module.exports = __webpack_public_path__ + "assets/img/bg.d859d004.png";